export default __webpack_public_path__ + "648280a965b76ac2c917f211b1866819.svg";